import { ConsentGoalDto } from '@act/shared/data-transfer-objects';
import { SummaryDateLine } from './SummaryDateLine';
import { timeFormatter } from '@act/shared/utilities';

interface ConsentSummaryDateLineProps {
  consent: ConsentGoalDto;
}

export const ConsentSummaryDateLine = ({
  consent,
}: ConsentSummaryDateLineProps) => {
  let text = '';

  if (consent.completed) {
    const action = consent.consented ? 'Consent accepted' : 'Consent rejected';
    text = `${action} on ${timeFormatter.epochToHumanReadableDate({
      date: consent.completedAt,
      showFullMonthName: true,
      excludeRelativeDay: true,
    })}`;
  }

  return <SummaryDateLine text={text} />;
};
